/**
 * Cycle layout — nodes evenly spaced around a circle with arrows linking each to the next
 * (wrapping back to the first).
 */
import { paletteColor, tintColor } from '../smartArtUtils';

const BOX_W = 28;
const BOX_H = 20;

export const layoutCycle = (nodes, theme) => {
  const boxes = [];
  const connectors = [];
  const n = nodes.length;
  if (!n) return { boxes, connectors };

  const cx = 50;
  const cy = 50;
  const radius = 35;
  // start at top (-90deg) and go clockwise
  const centers = nodes.map((_, i) => {
    const angle = (-90 + (360 / n) * i) * (Math.PI / 180);
    return { x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) };
  });

  nodes.forEach((node, i) => {
    const c = centers[i];
    boxes.push({
      nodeId: node.id,
      xPct: c.x - BOX_W / 2,
      yPct: c.y - BOX_H / 2,
      wPct: BOX_W,
      hPct: BOX_H,
      shapeType: 'oval',
      fill: paletteColor(theme, i),
      textColor: theme.textColor,
    });
  });

  if (n > 1) {
    // PowerPoint "Basic Cycle" connectors: chunky light-tinted block arrows.
    const arrowFill = tintColor(paletteColor(theme, 0), 0.45);
    centers.forEach((from, i) => {
      const to = centers[(i + 1) % n];
      connectors.push({
        x1Pct: from.x, y1Pct: from.y,
        x2Pct: to.x, y2Pct: to.y,
        kind: 'blockArrow',
        fill: arrowFill,
        gapPct: BOX_W / 2, // trim endpoints so arrows start/end at box edges
        // Animation reveals a connector with the node it leads into.
        toNodeId: nodes[(i + 1) % n].id,
      });
    });
  }
  return { boxes, connectors };
};
